<template>
    <div class="bio content-container">
        <div class="header">
            <div class="title">Bio</div>
        </div>        
        <div class="content">
            <div class="edit-large">
                <textarea rows="10" v-model="bio"></textarea>                        
            </div>
        </div>
        <div class="footer">
            <div class="footer-right">
                <button v-on:click="cancel" >Cancel</button>
                <button v-on:click="submit">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '../../api/api'
    import dialogs from '../../modules/dialogs';

    export default {

        props: ['bioInfo'],
        components: {
        },
        data() {
            return {
                id: null,
                bio: null,
                originalBio: null,
            }
        },
        methods: {
            submit() {

                let data = {};

                data.memberID = parseInt(this.id);
                data.bio = this.bio;

                api.post('/members/' + this.id + '/bio', data)
                    .then(async (response) => {
                        
                        this.modalIsConfirm = false;
                        if (response.data.success === true) {
                            this.originalBio = this.bio;
                            await dialogs.alertAsync("Saved");
                        } else {
                            await dialogs.alertAsync(response.data.message);
                        }
                    }
                ).catch(async (error) => {
                    await dialogs.alertAsync(error);
                });
            },
            async cancel() {
                if(await dialogs.confirmAsync("Are you sure you want to cancel edits to your bio?")) {
                    this.bio = this.originalBio;
                }
            }
        },
        mounted() {
            this.id = this.bioInfo.id;
            this.bio = this.bioInfo.bio;
            this.originalBio = this.bioInfo.bio;
        }

    }

</script>